import { render, staticRenderFns } from "./editsmspackage.vue?vue&type=template&id=1a4ddad1&"
import script from "./editsmspackage.vue?vue&type=script&lang=ts&"
export * from "./editsmspackage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editsmspackage.vue"
export default component.exports